import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FolderIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.42 6.94H20.28V18.54H3.72V4.92H8.84C9.42 4.92 9.76 5.16 10.12 5.44L11.66 6.66C11.88 6.84 12.08 6.94 12.42 6.94ZM18.44 16.7V8.78H11.78C11.2 8.78 10.86 8.54 10.5 8.26L8.96 7.04C8.74 6.86 8.54 6.76 8.2 6.76H5.56V16.7H18.44Z" />
    </SvgIcon>
  );
});
